<template>
  <dd-header-card
      header="Resultaten overzicht"
      :wide-content="hasAutomationResults"
  >
    <template #action>
      <dd-input
          v-model="customerName"
          @input="onSearch"
          placeholder="Zoek op klant voor- of achternaam"
          :style="{minWidth: 270}"
      />
    </template>
    <template v-if="!loaded">
      Laden ...
    </template>
    <dd-main-table
        v-else-if="!fetchingAutomationResults && hasAutomationResults"
        :headers="tableHeaders"
        :rows="automationResults"
        :paginator="automationResultsPagination"
        @load-page="reloadPage"
    />
    <template v-else-if="!hasAutomationResults">
      Er zijn nog geen resultaten voor deze automation.
    </template>
  </dd-header-card>
</template>

<script>
import store from './store'
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'
import CustomerAvatarCell from '../../../../new_design_components/tables/cell_types/CustomerAvatarCell.vue'
import { DateFormatEnum } from '../../../../enums'
import UserAvatarCell from '../../../../new_design_components/tables/cell_types/UserAvatarCell.vue'
import AutomationResultStateCell from '../tables/cell_types/AutomationResultStateCell.vue'
import AutomationResultActionCell from '../tables/cell_types/AutomationResultActionCell.vue'

export default {
  name: 'AutomationResultsHistory',
  beforeCreate () {
    const STORE_KEY = '$_automation_show'
    // eslint-disable-next-line no-underscore-dangle
    if (!(STORE_KEY in this.$store._modules.root._children)) {
      this.$store.registerModule(STORE_KEY, store)
    }
  },
  data () {
    return {
      loaded: false,
      tableHeaders: [
        {
          title: 'Status',
          width: '100px',
          typeComponent: AutomationResultStateCell,
          key: (automationResult) => automationResult
        },
        {
          title: 'Klant',
          typeComponent: CustomerAvatarCell,
          key: (automationResult) => automationResult.customer?.data
        },
        {
          title: 'Acties',
          typeComponent: AutomationResultActionCell,
          key: (automationResult) => automationResult
        },
        {
          title: 'Verwerkt op',
          width: '200px',
          key: (automationResult) => {
            if (automationResult.process_started_at) {
              return moment(automationResult.process_started_at).format(DateFormatEnum.DISPLAY_DATETIME)
            }
            return '-'
          }
        },
        {
          title: 'Genegeerd op',
          width: '200px',
          key: (automationResult) => {
            if (automationResult.ignored_at) {
              return moment(automationResult.ignored_at).format(DateFormatEnum.DISPLAY_DATETIME)
            }
            return ''
          }
        },
      ],
      loadPageObject: {
        page: 1,
        perPage: 15,
        total: 0,
      },
      customerName: '',
    }
  },
  created () {
    this.awaitResultsForAutomationInterface()
      .then(() => {
        this.loaded = true
      })

    if (this.automationInterface?.needs_verification) {
      this.insertVerifiedByColumn()
    }
  },
  watch: {
    automationResultsPagination () {
      this.loadPageObject = {
        page: this.automationResultsPagination.current_page,
        perPage: this.automationResultsPagination.per_page,
        total: this.automationResultsPagination.total,
      }
    },
    automationKey () {
      this.awaitResultsForAutomationInterface()
    },
  },
  methods: {
    ...mapActions('$_automation_show', {
      fetchAutomationResultsByAutomation: 'fetchAutomationResultsByAutomation',
      fetchAutomationResultsByGlobalAutomationConfiguration: 'fetchAutomationResultsByGlobalAutomationConfiguration',
    }),
    ...mapMutations(`$_automation_show`, {
      setAutomationResults: 'SET_AUTOMATION_RESULTS',
      setAutomationResultsPagination: 'SET_AUTOMATION_RESULTS_PAGINATION',
    }),
    onSearch: _.debounce(function () {
      this.performSearch()
    }, 500),
    performSearch () {
      this.reloadPage({
        page: 1,
        perPage: 15,
      })
    },
    reloadPage (newLoadPageObject) {
      this.loadPageObject = {
        page: newLoadPageObject.page,
        perPage: newLoadPageObject.perPage,
      }
      this.awaitResultsForAutomationInterface().then(() => {
        this.loaded = true
      })
    },
    awaitResultsForAutomationInterface () {
      if (this.automationInterface === null) {
        return Promise.resolve()
      }

      if (this.isGlobal) {
        return this.fetchAutomationResultsByGlobalAutomationConfiguration({
          globalAutomationConfigurationId: this.automationInterface.id,
          page: this.loadPageObject.page,
          perPage: this.loadPageObject.perPage,
          name: this.customerName,
        })
      }
      return this.fetchAutomationResultsByAutomation({
        automation: this.automationInterface,
        page: this.loadPageObject.page,
        perPage: this.loadPageObject.perPage,
        name: this.customerName,
      })
    },
    insertVerifiedByColumn () {
      this.tableHeaders = [
        ...this.tableHeaders.slice(0, 2),
        {
          title: 'Gecontroleerd door',
          width: '200px',
          typeComponent: UserAvatarCell,
          key: (automationResult) => {
            if (automationResult.requires_verification) {
              return automationResult.processed_by_user?.data || automationResult.ignored_by_user?.data
            }
            return null
          }
        },
        ...this.tableHeaders.slice(2),
      ]
    }
  },
  computed: {
    ...mapGetters(`$_automation_show`, [
      'automationInterface',
      'automationKey',
      'isGlobal',
      'hasAutomationResults',

    ]),
    ...mapState(`$_automation_show`, {
      automationResults: 'automationResults',
      fetchingAutomationResults: 'fetchingAutomationResults',
      automationResultsPagination: 'automationResultsPagination',
    }),
  }
}
</script>

<style scoped>

</style>
